module.exports = __webpack_public_path__ + "img/metro.4218e214.png";